package com.essntl.features.invoice.ui.addeditinvoice.components.sidebar

data class PriceDetailsUiState(
    val title: String,
    val price: Int,
    val quantity: Int = 1,
    val unitPrice: Int? = null,
)